/**
 * Libs
 */

/**
 * Types
 */
import { WalletProviderE } from '@tacans/shared-marketplace-layer';
import React, { useCallback } from 'react';
import { useAuthorized } from 'src/features/common/auth/hooks/auth.hooks';

/**
 * Hooks
 */
import { useCollectible } from 'src/features/common/collectible/hooks/collectible.hooks';
import { useGetNftWalletProvider } from 'src/features/common/collectible/hooks/use-get-nft-wallet-provider';
import Router from 'next/router';
import { useBlockChainsById, useGetDefaultWallet } from 'src/features/common/wallet/hooks/wallet.hooks';
import { ConnectWalletModal } from 'src/features/common/wallet/modals/connect-wallet-modal';

interface ActionWithAuthorizationI {
    callback: () => void;
}

export const useActionWithAuthorization = ({ callback }: ActionWithAuthorizationI) => {
    const isAuthorized = useAuthorized();
    const nft = useCollectible();
    const getNftWalletProvider = useGetNftWalletProvider();
    const getDefaultWallet = useGetDefaultWallet();
    const blockChainsById = useBlockChainsById();

    return useCallback(
        (event: React.SyntheticEvent) => {
            event.stopPropagation();
            const walletProvider = getNftWalletProvider(nft!);
            const wallet = getDefaultWallet(walletProvider);

            if (!isAuthorized) {
                Router.push('/login');
                return;
            }
            if (!wallet?.address) {
                ConnectWalletModal.open({
                    walletProvider: blockChainsById[nft?.blockchainId!]?.name as WalletProviderE,
                });
                return;
            }
            callback();
        },
        [getNftWalletProvider, nft, getDefaultWallet, isAuthorized, callback, blockChainsById]
    );
};
